import { isSSR } from 'app/packages/components';

type QueueId = string;

type QueueData = {
  estimatedTime: number;
  callBack: VoidFunction;
};

type QueueConfig = {
  timeout: number;
};

const queueConfig = {
  timeout: 1000,
};

const createAsyncQueue = ({ timeout }: QueueConfig) => {
  const queue = new Map<QueueId, QueueData>();
  let queueTimerId: number | null = null;

  function addToQueue(queueId: QueueId, callBack: VoidFunction) {
    if (isSSR) {
      return;
    }

    if (queue.has(queueId)) {
      queue.delete(queueId);

      if (!queue.size && queueTimerId) {
        clearTimeout(queueTimerId);
        queueTimerId = null;
      }

      return;
    }

    callBack();
  }

  const removeFromQueue = (
    queueId: QueueId,
    callBack: VoidFunction,
    cbRunDelay: number = timeout,
  ) => {
    if (queue.has(queueId)) {
      console.error('this key already has in async queue', queueId, queue);
      return;
    }

    const estimatedTime = Date.now() + cbRunDelay;
    queue.set(queueId, { estimatedTime, callBack });

    if (!queueTimerId) {
      startQueueTimer();
    }
  };

  const reStartQueue = () => {
    const currentDate = Date.now();

    queue.forEach(({ estimatedTime, callBack }, queueId) => {
      if (currentDate > estimatedTime) {
        callBack();
        queue.delete(queueId);
      }
    });

    if (queue.size) {
      return startQueueTimer();
    }

    if (queueTimerId) {
      clearTimeout(queueTimerId);
      queueTimerId = null;
    }
  };

  function startQueueTimer() {
    queueTimerId = window.setTimeout(reStartQueue, timeout);
  }

  return { addToQueue, removeFromQueue };
};

export const asyncQueue = createAsyncQueue(queueConfig);
